module.exports = __webpack_public_path__ + "img/battery_1.1e272fbf.png";